import { QueryFunction, QueryKey, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import { EventsParams, eventsQueryKeys, EventsResponse } from "features/events";

import { TransectionApiServices } from "../api/transection-api.service";

const { getBulkUploadList } = TransectionApiServices();


const getEventsQuery = (
    params: EventsParams,
    options?: UseQueryOptions<EventsResponse>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<EventsResponse>;
    options?: UseQueryOptions<EventsResponse>;
} => ({
    queryKey: eventsQueryKeys.list(params),
    queryFn: ({ signal }) => getBulkUploadList(params, { config: { signal } }) as any,
    ...options,
});


export const useGetBulkUploadList = (
    params: EventsParams,
    options?: UseQueryOptions<EventsResponse>,
) => {
    const { message } = App.useApp();

    return useQuery<EventsResponse, Error>(
        getEventsQuery(params, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            ...options,
        }),
    );
};